export default __webpack_public_path__ + "static/bg-shadow-white2-b5f16ba46b55564ea1da4d2da417fde9.svg";